import React, {useCallback, useMemo, useState} from 'react';
import ScenarioSupersede from '../../../scenario/common/ScenarioSupersede/ScenarioSupersede';
import {DialogGeneric} from '../../../../core/dialog/DialogGeneric';
import styles from '../VisualizationScenarioAction.module.scss';
import {ScenarioActionProps} from '../../../actionMenuTypes';

export const useScenarioSupersedeDialog = () => {
  const [openProps, setOpenProps] = useState<ScenarioActionProps>();
  const handleOnCancel = useCallback(() => {
    setOpenProps(undefined);
  }, []);
  const handleOnSuccess = useCallback(() => {
    setOpenProps(undefined);
    openProps?.onSuccess?.();
  }, [openProps]);

  const Component = useMemo(() => {
    return !openProps ? null : (
      <DialogGeneric open={true} title="Supersede Instance" childrenAsText={false} includesDialogActions={true}>
        <div className={styles.dialog}>
          <ScenarioSupersede
            onSuccess={handleOnSuccess}
            onCancel={handleOnCancel}
            model={openProps.model}
            subModel={openProps.subModel}
            scenario={openProps.scenario}
          />
        </div>
      </DialogGeneric>
    );
  }, [openProps, handleOnCancel, handleOnSuccess]);

  return {
    open: setOpenProps,
    Component,
  };
};
